'use client';

import { Typography } from '@mui/material';
import { COLORS } from '@/constants';
import { useMasterAdmin } from '@/contexts/masterAdmin';
import { useTranslations } from 'next-intl';
import { getBrokerInitials } from '../../utils';
import { BrokerAvatar, BrokerCard as BrokerCardWrapper, BrokerInfo } from '../../styled';
import { LoginButton } from './styled';
import type { ImpersonatedBroker } from '@/contexts/masterAdmin';

type BrokerCardProps = {
  broker: ImpersonatedBroker;
};

export const BrokerCard = ({ broker }: BrokerCardProps) => {
  const t = useTranslations('masterAdmin');
  const { loginAsBroker, isImpersonating, impersonatedBroker } = useMasterAdmin();

  const isActive = isImpersonating && impersonatedBroker?.id === broker.id;

  return (
    <BrokerCardWrapper>
      <BrokerAvatar>
        {broker.avatarUrl ? (
          <img src={broker.avatarUrl} alt={broker.name} />
        ) : (
          getBrokerInitials(broker.name)
        )}
      </BrokerAvatar>
      <BrokerInfo>
        <Typography fontWeight={700} fontSize={14} color={COLORS['primary/900']} noWrap>
          {broker.name}
        </Typography>
        <Typography fontSize={12} color={COLORS['neutral/500']} noWrap>
          {broker.officeName}
        </Typography>
      </BrokerInfo>
      <LoginButton
        variant="contained"
        disabled={isActive}
        onClick={() => {
          void loginAsBroker(broker);
        }}
      >
        <Typography fontSize={12} fontWeight={700}>
          {isActive ? t('activeButton') : t('loginButton')}
        </Typography>
      </LoginButton>
    </BrokerCardWrapper>
  );
};
